import { channelCreateResource } from '@api/vendor.service'

const WEBPUSH_TYPE = 'webpush'

export function initPushNotifications() {
  if ('undefined' === typeof window.es || !window.authent) return

  window.es('getPushToken', pushToken => {
    if (!pushToken) {
      console.log('Користувач ще не підписаний або не надав дозвіл.');
      return;
    }
    console.log('Web Push token:', pushToken)
    try {
      channelCreateResource.execute({}, { token: pushToken, type_channel: WEBPUSH_TYPE })
    } catch (error) {
      console.error('Error while creating channel:', error)
    }
  })
}
